export const JobStatusEmum = {
    ABERTO: "aberto",
    EM_ANDAMENTO: "em_andamento",
    FINALIZADO_PARCEIRO: "finalizado_parceiro",
    FINALIZADO_CLIENTE: "finalizado_cliente",
    AGUARDANDO_AGENDAMENTO: "aguardando_agendamento",
    MATERIAL_RECEBIDO: "material_recebido",
    MATERIAL_DISPONIBILIZADO: "material_disponibilizado",
    CANCELADO: "cancelado",
    EXPIRADO: "expirado",
    TESTE: "teste",
    AGUARDANDO_REVISAO: "aguardando_revisao",
    MATERIAL_EM_ANALISE: "material_em_analise",
    AGUARDANDO_CONFIRMACAO_AGENDAMENTO: "aguardando_confirmacao_agendamento",
    AGENDAMENTO_CONFIRMADO: "agendamento_confirmado",
    AGENDAMENTO_RECUSADO: "agendamento_recusado",
    EM_EXECUCAO: "em_execucao",
};

export const getStatusLabel = (status) => {
    switch (status) {
        case JobStatusEmum.ABERTO:
            return "Aberto";
        case JobStatusEmum.AGUARDANDO_CONFIRMACAO_AGENDAMENTO:
            return "Aguardando confirmação de agendamento";
        case JobStatusEmum.AGENDAMENTO_CONFIRMADO:
            return "Agendamento confirmado";
        case JobStatusEmum.AGENDAMENTO_RECUSADO:
            return "Agendamento recusado";
        case JobStatusEmum.EM_ANDAMENTO:
            return "Em Andamento";
        case JobStatusEmum.FINALIZADO_PARCEIRO:
        case JobStatusEmum.FINALIZADO_CLIENTE:
            return "Finalizado";
        case JobStatusEmum.AGUARDANDO_AGENDAMENTO:
            return "Aguardando Agendamento";
        case JobStatusEmum.CANCELADO:
            return "Cancelado";
        case JobStatusEmum.EXPIRADO:
            return "Expirado";
        case JobStatusEmum.TESTE:
            return "Teste";
        case JobStatusEmum.AGUARDANDO_REVISAO:
            return "Aguardando Revisão";
        case JobStatusEmum.MATERIAL_RECEBIDO:
            return "Material em processamento";
        case JobStatusEmum.MATERIAL_DISPONIBILIZADO:
            return "Material Disponibilizado";
        case JobStatusEmum.MATERIAL_EM_ANALISE:
            return "Material em Análise";
        case JobStatusEmum.NOSHOW:
            return "NoShow";
        case JobStatusEmum.EM_EXECUCAO:
            return "Em execução";
        default:
            return status;
    }
};

export const getStatusColor = (status) => {
    switch (status) {
        case JobStatusEmum.FINALIZADO_PARCEIRO:
        case JobStatusEmum.FINALIZADO_CLIENTE:
            return "#0DD735";
        case JobStatusEmum.CANCELADO:
        case JobStatusEmum.AGENDAMENTO_RECUSADO:
        case JobStatusEmum.NOSHOW:
            return "#F24A50";
        case JobStatusEmum.EXPIRADO:
            return "#F24A50";
        case JobStatusEmum.MATERIAL_DISPONIBILIZADO:
            return "#5064EE";
        case JobStatusEmum.MATERIAL_EM_ANALISE:
            return "#5064EE";
        default:
            return "#FE8418";
    }
};

export const getOrderedStatus = () => {
    return [
        { value: JobStatusEmum.AGUARDANDO_AGENDAMENTO, label: getStatusLabel(JobStatusEmum.AGUARDANDO_AGENDAMENTO) },
        { value: JobStatusEmum.ABERTO, label: getStatusLabel(JobStatusEmum.ABERTO) },
        {
            value: JobStatusEmum.AGUARDANDO_CONFIRMACAO_AGENDAMENTO,
            label: getStatusLabel(JobStatusEmum.AGUARDANDO_CONFIRMACAO_AGENDAMENTO),
        },
        { value: JobStatusEmum.AGENDAMENTO_CONFIRMADO, label: getStatusLabel(JobStatusEmum.AGENDAMENTO_CONFIRMADO) },
        { value: JobStatusEmum.AGENDAMENTO_RECUSADO, label: getStatusLabel(JobStatusEmum.AGENDAMENTO_RECUSADO) },
        { value: JobStatusEmum.EM_ANDAMENTO, label: getStatusLabel(JobStatusEmum.EM_ANDAMENTO) },
        { value: JobStatusEmum.MATERIAL_RECEBIDO, label: getStatusLabel(JobStatusEmum.MATERIAL_RECEBIDO) },
        {
            value: JobStatusEmum.MATERIAL_DISPONIBILIZADO,
            label: getStatusLabel(JobStatusEmum.MATERIAL_DISPONIBILIZADO),
        },
        { value: JobStatusEmum.FINALIZADO_CLIENTE, label: getStatusLabel(JobStatusEmum.FINALIZADO_CLIENTE) },
        { value: JobStatusEmum.CANCELADO, label: getStatusLabel(JobStatusEmum.CANCELADO) },
    ];
};

export const getCancelableStatus = () => {
    return [
        JobStatusEmum.AGUARDANDO_AGENDAMENTO,
        JobStatusEmum.ABERTO,
        JobStatusEmum.AGUARDANDO_CONFIRMACAO_AGENDAMENTO,
        JobStatusEmum.AGENDAMENTO_CONFIRMADO,
        JobStatusEmum.AGENDAMENTO_RECUSADO,
        JobStatusEmum.EM_ANDAMENTO,
    ];
};

export const getReschedulableStatus = () => {
    return [
        JobStatusEmum.ABERTO,
        JobStatusEmum.AGUARDANDO_CONFIRMACAO_AGENDAMENTO,
        JobStatusEmum.AGENDAMENTO_CONFIRMADO,
        JobStatusEmum.AGENDAMENTO_RECUSADO,
        JobStatusEmum.EM_ANDAMENTO,
    ];
};

export const getDeliveredStatus = () => {
    return [JobStatusEmum.MATERIAL_DISPONIBILIZADO, JobStatusEmum.FINALIZADO_CLIENTE];
};

export function statusToSelectAsArray() {
    return Object.entries(JobStatusEmum).reduce((acc, [key, value]) => {
        acc.push({ value, name: getStatusLabel(key) ?? value });
        return acc;
    }, []);
}
